<template>
  <div>
    <el-dialog :title="isCreate ? '新建版本邮件' : '修改版本邮件'" center :visible="true" @before-close="onClose" @close="onClose"
      :close-on-click-modal="false" :close-on-press-escape="false" width="830px">
      <el-form ref="form" :model="form" label-width="200px" size="mini">
        <el-form-item label="目标版本：">
          <el-input v-model="form.version" :disabled="!isCreate" placeholder="格式形如“1.2.3”"
            style="width: 150px"></el-input>
          <span>（玩家的客户端版本达到该目标版本时就会获得当前邮件）</span>
        </el-form-item>

        <el-form-item label="新玩家也能获得本邮件：">
          <el-switch v-model="form.canNewPlayerGet" active-color="#13ce66"></el-switch>
          <span>（这里的新玩家针对的是出生时所用的客户端版本恰好是目标版本）</span>
        </el-form-item>

        <el-form-item label="标题和正文：">
          <MailTemplate ref="mailTemplate" :languageTemplates="form.languageTemplates" style="width: 500px">
          </MailTemplate>
        </el-form-item>

        <el-form-item label="附件：">
          <MailAttachmentListBuilder ref="mailAttachmentListBuilder" :attachments="form.attachments">
          </MailAttachmentListBuilder>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

import MailTemplate from "@/pages/mail/components/MailTemplate";
import MailAttachmentListBuilder from "@/pages/mail/components/MailAttachmentListBuilder";

// 本弹窗名称
const DialogName = "EditVersionMailDialog";

export default {
  data() {
    return {
      isCreate: false,
      form: {
        version: "",
        canNewPlayerGet: false,
        languageTemplates: [],
        attachments: [],
      }
    }
  },

  components: {
    MailTemplate,
    MailAttachmentListBuilder,
  },

  created() {
    /**
     * params的类型应该是这样的：
     * 
      {
        isCreate: Boolean;
        existedData: Object;
        languageTemplates: Array;
      }
     */
    let params = this.$dialogutil.getData(DialogName);

    this.isCreate = params.isCreate;

    if (params.existedData) {
      this.form.version = params.existedData.version;
      this.form.canNewPlayerGet = params.existedData.canNewPlayerGet;
      this.form.languageTemplates = params.existedData.languageTemplates;
      this.form.attachments = JSON.parse(params.existedData.props);
    } else if (params.languageTemplates) {
      this.form.languageTemplates = params.languageTemplates;
    }
  },

  methods: {
    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },

    async submit() {
      let version = "";
      {
        version = this.form.version.trim();

        let versionNumberStrs = version.split(".");
        if (versionNumberStrs.length == 0) {
          this.$message({
            message: "请正确填写目标版本",
            type: "error",
          });
          return;
        }

        for (let versionNumberStr of versionNumberStrs) {
          if (parseInt(versionNumberStr).toString() != versionNumberStr) {
            this.$message({
              message: "请正确填写目标版本",
              type: "error",
            });
            return;
          }
        }
      }

      // 取得邮件模板
      let mailTemplate = {};
      {
        let getDataResult = this.$refs.mailTemplate.getData();
        if (getDataResult.errorMessage) {
          this.$message({
            message: getDataResult.errorMessage,
            type: "error",
          });
          return;
        }

        mailTemplate = {
          languageTemplates: getDataResult.data.languageTemplates,
        }
      }

      // 取得附件集合
      let attachments = [];
      {
        let getDataResult = this.$refs.mailAttachmentListBuilder.getData();
        if (getDataResult.errorMessage) {
          this.$message({
            message: getDataResult.errorMessage,
            type: "error",
          });
          return;
        }

        attachments = getDataResult.data.attachments;
      }

      let requestBody = {};
      {
        let mail = {
          version: version,
          canNewPlayerGet: this.form.canNewPlayerGet,
          languageTemplates: mailTemplate.languageTemplates,
          props: JSON.stringify(attachments),
        };

        if (this.isCreate) {
          requestBody = {
            action: "create",
            create: {
              mail: mail,
            }
          }
        } else {
          requestBody = {
            action: "update",
            update: {
              mail: mail,
            }
          }
        }
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/manageVersionMails`,
          requestBody,
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      this.$message({
        message: "保存成功",
        type: "success",
      });

      // 关闭当前对话框
      this.onClose();
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: white;
  color: black;
}
</style>